import { render } from "./ApplicationDetailsPage.vue?vue&type=template&id=66a0474d"
import script from "./ApplicationDetailsPage.vue?vue&type=script&lang=js"
export * from "./ApplicationDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__